import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 17 16\" id=\"error\"><path fill=\"#EF454A\" stroke=\"#EF454A\" stroke-linejoin=\"round\" stroke-width=\"1.333\" d=\"M8.667 14.667a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334Z\" /><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.167\" d=\"m11 5.667-4.667 4.666M6.333 5.667 11 10.333\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol